import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

const spinner = {
  to: {
    transform: 'rotate(360deg)'
  }
};

export const styles = StyleSheet.create({
  loaderWrapper: {
    position: 'relative',
    padding: 24
  },
  loader: {
    textIndent: '-9999em',
    display: 'block',
    ':before': {
      content: `''`,
      boxSizing: 'border-box',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '30px',
      height: '30px',
      marginTop: '-15px',
      marginLeft: '-15px',
      borderRadius: '50%',
      border: `1px solid ${colour.grey[400]}`,
      borderTopColor: '#fff',
      animationName: spinner,
      animationTimingFunction: 'linear',
      animationDuration: '.6s',
      animationIterationCount: 'infinite'
    }
  },
  loaderOnDark: {
    ':before': {
      borderColor: '#fff',
      borderTopColor: 'transparent'
    }
  },
  title: {
    fontWeight: 600,
    display: 'block',
    marginTop: 60,
    fontSize: 14,
    textAlign: 'center',
    color: colour.grey[400]
  },
  titleOnDark: {
    color: '#fff'
  }
});
